import { StepType, useTour } from '@reactour/tour';
import Content from 'ui/components/common/Tour/Content';
import { TOUR_SELECTOR } from 'ui/partials/Tour';
import { useProvider } from 'utils/providers/Provider';

const useGetHowToSetupPipelineSteps = () => {
  const { dispatch, state } = useProvider();
  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  const isCollapsed = state?.collapse;

  const setupPipelineSteps: StepType[] = [
    {
      content: 'Go to the Sales Menu Tab',
      position: 'right',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.MENU}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(1), 500);
          },
          false,
        );
      },
    },
    {
      content: 'Then select Deals to view the Deals page.',
      position: 'right',
      padding: { popover: [0, 0, 0, 30] },
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.DEAL.SUBMENU}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(2), 500);
          },
          false,
        );
      },
    },
    {
      content:
        // eslint-disable-next-line max-len
        'Select the Gear icon next to the Create Deal button, and you will be directed to the Sales Deal Settings page.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.DEAL.SETTINGS_BUTTON}"]`,
      padding: { popover: [-30, -35] },
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(3), 1000);
          },
          false,
        );
      },
    },
    {
      content: 'Click on the Create button',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.NEW_TILE_BUTTON}"]`,
      padding: { popover: [-90, -50] },

      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(4), 300);
          },
          false,
        );
      },
    },
    {
      content: (props) => (
        <Content
          {...props}
          type="Pipeline Name"
          content="Type in the name of the pipeline"
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.NEW_TILE_FORM}"]`,
      stepInteraction: false,
    },
    {
      content: 'Click the check button to save and you are done',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.NEW_TILE_SAVE}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(6), 500);
          },
          false,
        );
      },
    },
    {
      content: (props) => (
        <Content
          content="You can view your created pipeline here."
          {...props}
          endTour
        />
      ),
      selector: `[data-rbd-droppable-id="pipelineSettings"]`,
      stepInteraction: false,
    },
  ];

  const showSetupPipelineSteps = () => {
    if (isCollapsed) {
      dispatch?.({ type: 'toggleSidebar' });
    }
    setTimeout(() => {
      setSteps?.(setupPipelineSteps);
      setIsOpen(true);
    }, 300);
  };

  return showSetupPipelineSteps;
};

export default useGetHowToSetupPipelineSteps;
